import { render, staticRenderFns } from "./IncotermsManagement.vue?vue&type=template&id=35906182&"
import script from "./IncotermsManagement.vue?vue&type=script&lang=js&"
export * from "./IncotermsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports